@for (phase of phaseSubmissions(); track phase.phaseId) {
  <div class="phase-section">
    <h4 class="phase-name">{{ phase.phaseName }}</h4>

    @if (phase.submission) {
      <div class="submission-fields">
        @for (field of phase.fields; track field.id) {
          <div class="field-row">
            <strong class="field-label">{{ field.label }}:</strong>
            <span class="field-value">
              {{ getDisplayValue(field, phase.submission!.data[field.id]) }}
            </span>
          </div>
        }
        <div class="submission-meta">
          <span class="meta-text">
            Preenchido por {{ phase.submission!.submittedBy }}
            em {{ phase.submission!.submittedAt | date: 'dd/MM/yyyy HH:mm' }}
          </span>
        </div>
      </div>
    } @else {
      <p class="empty-state">Nenhum formulário preenchido para esta fase.</p>
    }
  </div>
} @empty {
  <p class="empty-state">Nenhuma fase possui formulário configurado.</p>
}
